export const appRestart = async () => {
	window.location.reload();
}
